import api from "./base-api"

const mcPrefabApiV2 = api.injectEndpoints({
    endpoints: (build) => ({
        getPrefabV2MC: build.query({
            query: (id = "") => `v2/mc/prefabs/${id}`,
            providesTags: (result, error, arg) => {
                return result
                    ? [{type: 'PrefabItemMC', id:result.id}, 'PrefabItemMC']
                    : ['PrefabItemMC']
            }
        }),
        getPrefabStringV2MC: build.query({
            query: (id = "") => `v2/mc/prefabs/${id}/string`,
            providesTags: (result, error, arg) => {
                return result
                    ? [{type: 'PrefabItemMC', id:result.id}, 'PrefabItemMC']
                    : ['PrefabItemMC']
            }
        }),
        getPrefabsListV2MC: build.query({
            query: (id = "") => `v2/mc/prefabs`,
            transformResponse(data) {
                return data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
            },
            providesTags: ['PrefabsMC']
        }),
        getPrefabsInfosV2MC: build.query({
            query: (id = "") => `v2/mc/prefabs/infos`,
            transformResponse(data) {
                return data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
            },
            providesTags: ['PrefabsMC']
        }),
        getPrefabsInfoListV2MC: build.query({
            query: (id = "") => `v2/mc/prefabs/info`,
            transformResponse(data) {
                return data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
            },
            providesTags: ['PrefabsMCInfo']
        }),
        getPrefabsMetaMC: build.query({
            query: (id = "") => `v2/mc/prefabs/metas`,
            providesTags: ['PrefabsMetasMC']
        }),
        getPrefabsMeta: build.query({
            query: (game = "") => `v2/${game}/prefabs/metas`,
            providesTags: ['PrefabsMetasMC']
        }),
        createPrefabV2MC: build.mutation({
            query: (body = {}) => ({
                url: "v2/mc/prefabs",
                method: "POST",
                body: body.data,
                env: body.env
            }),
            invalidatesTags: ['PrefabsMC','PrefabsMetasMC']
        }),
        deletePrefabV2MC: build.mutation({
            query: (id = "") => ({
                url: `v2/mc/prefabs/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ['PrefabsMC','PrefabsMCInfo']

        }),
        updatePrefabV2MC: build.mutation({
            query: (data = {}) => ({
                url: `v2/mc/prefabs/${data.id}`,
                method: "PUT",
                body: data.body
            }),
            invalidatesTags: ['PrefabItemMC','PrefabsMCInfo']

        })
    }),
    overrideExisting: false
})

export const {
    useGetPrefabV2MCQuery,
    useGetPrefabsMetaMCQuery,
    useGetPrefabsMetaQuery,
    useGetPrefabStringV2MCQuery,
    useGetPrefabsListV2MCQuery,
    useGetPrefabsInfoListV2MCQuery,
    useGetPrefabsInfosV2MCQuery,
    useCreatePrefabV2MCMutation,
    useDeletePrefabV2MCMutation,
    useUpdatePrefabV2MCMutation
} = mcPrefabApiV2
